<la-button
  class="upgrade-button"
  appearance="outlined"
  icon="diamond"
  [disabled]="disabled"
  [buttonLink]="buttonLink"
  (action)="action.emit()"
>
  {{ text }}
</la-button>
